import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ea59dd4")

_pushScopeId("data-v-5ea59dd4")
const _hoisted_1 = {
  key: 0,
  style: {"width":"80%"},
  class: "flex align-center"
}
const _hoisted_2 = { class: "margin-left-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")

  return (_openBlock(), _createBlock(_component_el_steps, {
    direction: "vertical",
    active: -1,
    "align-center": ""
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slices, (slice) => {
        return (_openBlock(), _createBlock(_component_el_step, {
          key: slice.id,
          title: _ctx.getTitle(slice)
        }, {
          description: _withId(() => [
            _createVNode(_component_el_card, null, {
              default: _withId(() => [
                (slice.sliceId !== -1)
                  ? (_openBlock(), _createBlock("div", _hoisted_1, [
                      _createVNode("audio", {
                        class: "margin-left-10",
                        src: slice.audio,
                        controls: ""
                      }, null, 8, ["src"]),
                      _createVNode("pre", _hoisted_2, _toDisplayString(slice.words), 1)
                    ]))
                  : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["title"]))
      }), 128))
    ]),
    _: 1
  }))
})